module.exports = __webpack_public_path__ + "static/media/how-it-works2.e219fc9f.png";